import AuthSplitLayout from 'layouts/AuthSplitLayout';
import bg from 'assets/img/bg/Avatar.png';
import CheckoutForm from 'components/modules/auth/SignUpForm';

const SignUp = () => {
  return (
    <AuthSplitLayout bg={bg}>
      <CheckoutForm layout="split" />
    </AuthSplitLayout>
  );
};

export default SignUp;
